<template>
    <div class="major">
        <div class="major-header">
            <i ref="backRef" @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i>
            <span>FEE</span>
        </div>
        <div class="major-main">
            <div>
                <van-cell v-for="(_, index) in list" :key="index" @click="changeSelect(index)" :class="{ 'active-cell': index === active }">
                    <van-panel>
                        <template #header>
                            <div class="item-top dis-ben">
                                <div>{{_.description}}</div>
                                <div>{{_.time}}</div>
                            </div>
                            <div class="item-bottom dis-ben">
                                <div>{{_.sat}}</div>
                                <div>{{_.usd}}</div>
                            </div>
                        </template>
                        <template #default>
                            <div class="item-content" v-if="index === active && (!inpIndex && inpIndex !== 0)" :key="1">
                                <div class="item-content-top dis-ben">
                                    <div>Sats in Inscription</div>
                                    <div>546 sats ≈ 0.23 USDT</div>
                                </div>
                                <div class="item-content-bottom dis-ben">
                                    <div>Service fee</div>
                                    <div>1,000 sats ≈ 0.43 USDT</div>
                                </div>
                            </div>
                            <div class="item-content-inp" v-else-if="index === inpIndex" :key="2">
                                <p class="item-content-inp-cy">Sat/vB</p>
                                <cu-field v-model="inpValue" />
                                <van-button @click="edit(index)" style="width: 100%">{{"修改"}}</van-button>
                            </div>
                        </template>
                    </van-panel>
                </van-cell>
            </div>
        </div>
        <div class="major-footer">
            <van-button @click="confirmOrder()">确认下单</van-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { removeCookie, removeLanguage } from '../../utils/auth'
import { Cell, CellGroup, Panel, Button, Toast } from 'vant'
import cuField from './compontents/cuField.vue'

export default {
    name: 'ConfirmOrder',
    components: {
        // vanTab: Tab,
        // vanTabs: Tabs,
        vanPanel: Panel,
        vanCellGroup: CellGroup,
        vanCell: Cell,
        vanButton: Button,
        CuField: cuField,
    },
    data() {
        return {
            active: 1,
            inpValue: '',
            inpIndex: '',
            titleWidth: '',
        }
    },
    created() {},
    mounted() {},
    beforeDestroy() {},
    computed: {
        ...mapGetters([
            'token',
            'styleType',
            'isDirection',
            'languageName',
            'language',
            'isApp',
        ]),
        // list() {
        //     return Array.from({ length: 4 }).map((_, index) => index)
        // },
        list() {
            return [
                {
                    description: 'Slow',
                    time: '> 60 mins',
                    sat: '306 sat/vB',
                    usd: '545 sats ≈ 5.31 USDT',
                },
                {
                    description: 'Average',
                    time: '≈ 30 mins',
                    sat: '318 sat/vB',
                    usd: '560 sats ≈ 5.50 USDT',
                },
                {
                    description: 'Fast',
                    time: '≈ 10 mins',
                    sat: '323 sat/vB',
                    usd: '580 sats ≈ 5.70 USDT',
                },
                {
                    description: 'Custom',
                    time: '≈ 10 mins',
                    sat: '1000 sat/vB',
                    usd: '600 sats ≈ 5.90 USDT',
                },
            ]
        },
    },
    watch: {},
    methods: {
        changeSelect(index) {
            console.log('看看这个是不是再这里')
            console.log(index, '看看这个index')
            // 重置输入项
            this.inpIndex = ''
            // TODO 点击为当前已选中的行 则弹出输入（需要再加其他&&判断）
            if (this.active === 3 && this.active === index) {
                console.log(this.active, '---active---')
                this.inpIndex = index
            }
            this.active = index
        },
        edit(index) {
            // TODO 修改
            if (!this.inpValue) {
                Toast('请输入')
                return
            }
            // 异步操作
            const timer = setTimeout(() => {
                this.inpIndex = ''
                this.inpValue = ''
                clearTimeout(timer)
            }, 0)
        },
        confirmOrder() {
            // TODO 账单确认
            if (!this.active) {
                return Toast('请选择')
            }
            this.$router.push({
                path: '/tokenDetails',
                query: {
                    id: this.active,
                },
            })
        },
        goBack() {
            // console.log(this.$route)
            if (this.$route.query.isApp) {
                removeCookie()
                removeLanguage()
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.goBack,
                    {},
                    (data) => {}
                )
            } else {
                this.$router.go(-1)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variableName.scss';
@import '../../style/mixin';
.major {
    &-header {
        width: 100%;
        // background-color: #17171a;
        z-index: 9999;
        // position: absolute;
        padding-top: torem(44);
        padding: 0 torem(19);
        box-sizing: border-box;
        height: torem(51);
        // background-color: #000000;
        display: flex;
        align-items: center;
        text-align: center;
        position: relative;
        i {
            font-size: torem(16);
            // width: torem(9.62);
            // height: torem(17);
            color: #333333;
        }
        span {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: torem(16);
            // width: 100%!important;
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.9);
            margin: 0 auto;
        }
    }
    &-main {
        padding: torem(20) torem(16) torem(16) torem(16);
        .dis-ben {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .item-top {
            padding: torem(16);
            font-size: torem(16);
            color: rgba(0, 0, 0, 0.6);
        }
        .item-bottom {
            padding: torem(16);
            font-size: torem(12);
            color: rgba(0, 0, 0, 0.6);
            padding-top: 0;
        }
        .item-content {
            width: 100%;
            background-color: rgba(0, 0, 0, 0.65);
            &-top,
            &-bottom {
                font-size: torem(12);
                color: rgba(255, 255, 255, 1);
                padding: torem(16);
            }
            &-bottom {
                padding-top: 0;
            }
        }
        .item-content-inp {
            padding: torem(16);
            padding-top: 0;
            &-cy {
                padding-bottom: torem(8);
                font-size: torem(12);
                color: rgba(0, 0, 0, 0.6);
            }
            /deep/ .van-field__control {
                width: torem(310);
                height: torem(40);
                line-height: torem(40);
                // border-radius: torem(2);
                font-size: torem(32);
                @include sc(torem(14), #333);
                padding: 0 torem(15);
                background-color: #fff;
            }
            /deep/ .van-cell {
                border-radius: torem(2);
                border: torem(0.5) solid #dcdfe6;
            }
            /deep/ .van-button {
                background-color: rgba(255, 199, 43, 1);
            }
        }
        /deep/ .van-cell {
            padding: 0;
            border-radius: torem(8);
            opacity: 1;
            border: torem(0.5) solid #000;
            margin-bottom: torem(20);
        }
        /deep/ .van-cell::after,
        .van-cell-group::after {
            border: none;
        }
        .active-cell {
            .item-top,
            .item-bottom {
                color: #000;
            }
        }
    }
    &-footer {
        padding: torem(20) torem(16) torem(16) torem(16);
        /deep/ .van-button {
            width: 100%;
            height: torem(44);
            font-size: torem(14);
            color: #fff;
            background-color: rgba(0, 0, 0, 1);
            border-radius: torem(16);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/InscriptionArea/confirmOrder.vue